import React from 'react';

import classNames from 'classnames';
import { PERIOD_DAYS, PERIOD_MONTHS, PERIOD_QUARTERS, PERIOD_YEARS } from 'Constants/project_plan';

import SegmentedControl from 'CommonComponents/SegmentedControl';

/**
 * Shared by the Project Plan and the Milestone Roadmap — both draw the same control.
 *
 * `inline` lays the label out beside the control rather than above it, for the Project Plan's
 * single toolbar row. Stacked stays the default: the Roadmap still draws this inside a controls
 * panel, where a caption above each control is the right shape.
 */
const PeriodSelector = ({ period, onChange, inline = false }) => {
    const options = [
        { value: PERIOD_DAYS, label: $t('Days') },
        { value: PERIOD_MONTHS, label: $t('Months') },
        { value: PERIOD_QUARTERS, label: $t('Quarters') },
        { value: PERIOD_YEARS, label: $t('Years') },
    ];

    return (
        <div className={inline ? 'tw-flex tw-items-center tw-gap-x-2' : 'tw-flex tw-flex-col tw-flex-shrink'}>
            {/* `.inbud-control-label` is a stacked caption — a block with a bottom margin — so the
                inline row cancels the margin rather than introducing a second label style. */}
            <span className={classNames('inbud-control-label', { '!tw-mb-0': inline })}>{$t('View By')}</span>
            <SegmentedControl variant="track" options={options} value={period} onChange={onChange} />
        </div>
    );
};

export default PeriodSelector;
